import { DateOnly } from "src/modules/sm-base/models/date-only.model";
import { Transform } from "class-transformer";
export class Holiday {
    @Transform(({ value }) => typeof value === "string" ? DateOnly.parse(value) : value)
    date: DateOnly;
    title: string;
    halfDay = false;
}
